// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"2ec68e43","228":"60a1e29d","260":"5451f7ff"}[chunkId] + ".chunk.js";
};